import { services } from '../../../api';
import { Result } from '../../../shared/utils/enums';

/**
 * Submits a video completion status to the server.
 *
 * @param {number} videoId - The unique identifier of the video
 * @returns {Promise<boolean>} True if submission was successful, false otherwise
 *
 * @example
 * const isSuccess = await submitVideo(123);
 */
export const submitVideo = async (videoId: number): Promise<boolean> => {
  try {
    const res = await services.courses.submitVideo(videoId);
    return res.result === Result.Success;
  } catch (e) {
    console.error('Error submitting video completion:', e);
    return false;
  }
};
